import { apiPut } from '../../../utils';
import { UpdateDfiReportRequest } from '../../types';
import { EmptyObject } from '../../../../types';

export const updateDfiAnnualReport = (request: UpdateDfiReportRequest): Promise<EmptyObject> =>
  apiPut<EmptyObject, UpdateDfiReportRequest>(
    `reports/dfiAnnual/${request.reportYear}`,
    request
  );
